import styled from 'styled-components';
import { Nav as BaseNav } from 'reactstrap';
import { useSelector } from 'react-redux';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import { useLeaderboardTabsView } from '@paradigm/features/src/leaderboard/contexts/tabs';
import { selectIsUserPrime } from '@paradigm/store/auth';
import PrimeBadge from '@paradigm/design-system/src/assets/PrimeBadge';
import LeaderboardLiquidityTab from './liquidity/LeaderboardLiquidityTab';
import LeaderboardVolumeTab from './volume/LeaderboardVolumeTab';
import { Tab } from './shared/components';

export default function LeaderboardTabs() {
  const isPrimeUser = useSelector(selectIsUserPrime);

  return (
    <Nav role="tablist">
      <Divider />
      <Tab tabId="volume" label="Leaderboard Volume Tab">
        Volume
      </Tab>
      <Divider />
      <Tab
        tabId="liquidity"
        linkedTabs={['liquidity-fills', 'liquidity-responses']}
        label="Leaderboard Liquidity Tab"
        badge={<PrimeBadge css="margin-right: 6px;" />}
        disabled={!isPrimeUser}
      >
        Liquidity Providers
      </Tab>
    </Nav>
  );
}

export function LeaderboardTabContent() {
  const { activeTab } = useLeaderboardTabsView();

  return (
    <>
      {activeTab === 'volume' && <LeaderboardVolumeTab />}
      {activeTab.includes('liquidity') && <LeaderboardLiquidityTab />}
    </>
  );
}

const Divider = styled.div`
  width: 2px;
  height: 30px;
  margin-bottom: 5px;
  background: linear-gradient(
    50deg,
    rgba(238, 238, 238, 0) 0%,
    rgba(216, 216, 216, 0.2) 53.67%,
    rgba(216, 216, 216, 0) 100%
  );

  &:first-child {
    @media screen and (max-width: ${MOBILE_BREAKPOINT}px) {
      display: none;
    }
  }
`;

const Nav = styled(BaseNav)`
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin: auto;
    width: 100%;
    justify-content: center;
  }
`;
